import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBackward,
  faFastBackward,
  faFastForward,
  faFolderOpen,
  faForward,
  faPause,
  faPlay,
  faStepBackward,
  faStepForward,
} from "@fortawesome/free-solid-svg-icons";

import "./mediaPanel.css";

const largeDelta = 10;
const smallDelta = 1;
const frameDelta = 0.034; //guestimating 30fps

export default class MediaPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.requestFrameBack = this.requestTime.bind(this, -frameDelta, true);
    this.requestLargeBack = this.requestTime.bind(this, -largeDelta, false);
    this.requestSmallBack = this.requestTime.bind(this, -smallDelta, false);
    this.requestSmallForward = this.requestTime.bind(this, smallDelta, false);
    this.requestLargeForward = this.requestTime.bind(this, largeDelta, false);
    this.requestFrameForward = this.requestTime.bind(this, frameDelta, true);
  }

  componentDidMount() {
    if (this.props.playerContext) {
      this.props.playerContext.onContextStateChanged(
        this.playerStateChanged.bind(this)
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.playerContext !== prevProps.playerContext &&
      this.props.playerContext
    ) {
      this.props.playerContext.onContextStateChanged(
        this.playerStateChanged.bind(this)
      );
    }
  }

  playerStateChanged(state) {
    this.setState({ ...state });
  }

  requestTime(delta, pause) {
    const currentTime = this.props.playerContext.videoInformation.videoPosition;
    if (pause) {
      this.props.playerContext.requestPause();
    }
    this.props.playerContext.requestTime(currentTime + delta);
  }

  render() {
    if (!this.props.playerContext) return null;

    return (
      <div className="mediaPanel">
        <div>
          <div className="buttonBank">
            <button
              type="button"
              onClick={this.requestFrameBack}
              title="Back one frame"
            >
              <FontAwesomeIcon icon={faStepBackward} size="1x" />
            </button>
            <button
              type="button"
              onClick={this.requestLargeBack}
              title="Back 10 seconds"
            >
              <FontAwesomeIcon icon={faFastBackward} size="1x" />
            </button>
            <button
              type="button"
              onClick={this.requestSmallBack}
              title="Back 1 second"
            >
              <FontAwesomeIcon icon={faBackward} size="1x" />
            </button>
          </div>
          <div className="buttonPlayPause">
            <button
              type="button"
              onClick={
                this.state.playing
                  ? this.props.playerContext.requestPause
                  : this.props.playerContext.requestPlay
              }
              title={this.state.playing ? "Pause" : "Play"}
            >
              <FontAwesomeIcon
                icon={this.state.playing ? faPause : faPlay}
                size="2x"
              />
            </button>
          </div>
          <div className="buttonBank">
            <button
              type="button"
              onClick={this.requestSmallForward}
              title="Forward 1 second"
            >
              <FontAwesomeIcon icon={faForward} size="1x" />
            </button>
            <button
              type="button"
              onClick={this.requestLargeForward}
              title="Forward 10 seconds"
            >
              <FontAwesomeIcon icon={faFastForward} size="1x" />
            </button>
            <button
              type="button"
              onClick={this.requestFrameForward}
              title="Forward one frame"
            >
              <FontAwesomeIcon icon={faStepForward} size="1x" />
            </button>
          </div>
        </div>
        <div className="buttonOpenFiles">
          <button
            type="button"
            onClick={this.props.playerContext.requestOpenFiles}
            title="Select Files"
          >
            <FontAwesomeIcon icon={faFolderOpen} size="1x" />
          </button>
        </div>
      </div>
    );
  }
}
